import { useRouter } from 'next/router';
import useStore from '@pkg/auth/useStore';
import useClient from '@pkg/client/useClient';
import Sdk from '@pkg/sdk';
import AccountDisabled from '@/components/AccountDisabled';
import NotRegistered from '@/components/NotRegistered';
import AppLoading from './AppLoading';

const FRONTEGG_BASE_ROUTE = '/account/';
const FRONTEGG_CALLBACK_ROUTE = '/oauth/callback';
const FRONTEGG_TOKEN_ROUTE = '?code=';

export default function Middleware({ children }) {
  const isAuthenticated = useStore((state) => state.isAuthenticated);
  const isDisabled = useStore((state) => state.isDisabled);
  const isLoading = useStore((state) => state.isLoading);
  const isRegistered = useStore((state) => state.isRegistered);
  const router = useRouter();
  const client = useClient();

  // The auth store survives remounts; the token provider does not. Wait for
  // token restoration before mounting components that issue account requests.
  if (isLoading || (isAuthenticated && !client?.isAuthorized)) {
    return (
      <AppLoading
        reason="Middleware.isLoading"
        messages={['Pulling up your account...', '⚡ Almost ready to roll!']}
      />
    );
  }

  if (isAuthenticated && !isRegistered) {
    return <NotRegistered />;
  }

  if (isAuthenticated && isDisabled) {
    return <AccountDisabled />;
  }

  if (
    isAuthenticated &&
    !window?.location.pathname.startsWith(FRONTEGG_BASE_ROUTE) &&
    !window?.location.pathname.startsWith(FRONTEGG_CALLBACK_ROUTE)
  ) {
    const savedRoute = localStorage.getItem('_REDIRECT_AFTER_LOGIN_');
    if (savedRoute) {
      localStorage.removeItem('_REDIRECT_AFTER_LOGIN_');
      router.replace(Sdk.sanitizePath(savedRoute));
      return null;
    }
  }

  if (
    window?.location.href.includes(FRONTEGG_TOKEN_ROUTE) &&
    window?.location.href.includes('#layout=list')
  ) {
    localStorage.setItem('_ROLE_LIST_LAYOUT_', true);
  }

  return <>{children}</>;
}
